import React, { useRef, useState } from 'react';
import SignatureCanvas, { SignatureCanvasHandle } from './SignatureCanvas';

interface IGMSignatureModalProps {
    isOpen: boolean;
    onSave: (signatureImage: string, signeeName: string, position?: string) => void;
    onCancel: () => void;
    title?: string;
    showPosition?: boolean;
}

const GMSignatureModal: React.FC<IGMSignatureModalProps> = ({ isOpen, onSave, onCancel, title, showPosition }) => {

    const canvasRef = useRef<SignatureCanvasHandle>(null);
    const [signeeName, setSigneeName] = useState('');
    const [nameError, setNameError] = useState('');
    const [position, setPosition] = useState('');
    const [positionError, setPositionError] = useState('');

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!signeeName.trim()) {
            setNameError('Please enter your name.');
            return;
        }
        if (showPosition && !position.trim()) {
            setPositionError('Please enter a position.');
            return;
        }
        const image = await canvasRef.current?.getImage();
        onSave(image ?? '', signeeName.trim(), showPosition ? position.trim() : undefined);
        setSigneeName('');
        setNameError('');
        setPosition('');
        setPositionError('');
    };

    const handleCancel = () => {
        setSigneeName('');
        setNameError('');
        setPosition('');
        setPositionError('');
        onCancel();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="center-middle">
                    <div className="font-size-17px">
                        <h1>{title || 'Sign Below'}</h1>
                    </div>
                </div>

                <div style={{ marginBottom: '12px' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 600, fontSize: '14px' }}>
                        Name of Signee
                    </label>
                    <input
                        type="text"
                        value={signeeName}
                        onChange={(e) => {
                            setSigneeName(e.target.value);
                            if (nameError) setNameError('');
                        }}
                        placeholder="Enter full name"
                        style={{
                            width: '100%',
                            padding: '8px 10px',
                            border: nameError ? '1px solid red' : '1px solid #ccc',
                            borderRadius: '6px',
                            fontSize: '14px',
                            boxSizing: 'border-box',
                        }}
                    />
                    {nameError && (
                        <span style={{ color: 'red', fontSize: '12px' }}>{nameError}</span>
                    )}
                </div>

                {showPosition && (
                    <div style={{ marginBottom: '12px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontWeight: 600, fontSize: '14px' }}>
                            Position
                        </label>
                        <input
                            type="text"
                            value={position}
                            onChange={(e) => {
                                setPosition(e.target.value);
                                if (positionError) setPositionError('');
                            }}
                            placeholder="Enter position"
                            style={{
                                width: '100%',
                                padding: '8px 10px',
                                border: positionError ? '1px solid red' : '1px solid #ccc',
                                borderRadius: '6px',
                                fontSize: '14px',
                                boxSizing: 'border-box',
                            }}
                        />
                        {positionError && (
                            <span style={{ color: 'red', fontSize: '12px' }}>{positionError}</span>
                        )}
                    </div>
                )}

                <SignatureCanvas ref={canvasRef} newImageValue={() => {}} />

                <br />
                <div className="center-middle">
                    <button
                        type="button"
                        className="btn-save-signature center-middle"
                        onClick={handleSave}
                    >Save Signature</button>
                    &nbsp; &nbsp;
                    <button
                        type="button"
                        className="btn-white-green-2 center-middle"
                        onClick={handleCancel}
                    >Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default GMSignatureModal;
